import React, {
	useCallback,
} from 'react';
import { LaytimeTerms } from '@shared/utils/constants';
import type {
	GetCargoDetailsResponse,
} from '@api/features/cargos/getCargoDetails';
import EditableDetails from '@client/components/EditableDetails/EditableDetails';
import type { OnUpdateCargo } from '@client/screens/estimates/details/context/hooks/useCargoHandlers';
import { getLaytimeFields } from './helpers/getLaytimeFields';
import { ModalModes } from './CargoDetailsScreen';

type Props = {
	mode: ModalModes;
	cargoDetails: GetCargoDetailsResponse | undefined;
	laytimeTerms: LaytimeTerms;
	handleChange: OnUpdateCargo;
};

const LaytimeDetails = ({
	mode,
	cargoDetails,
	laytimeTerms,
	handleChange,
}: Props) => {
	const handleEdit = useCallback(async (values: Partial<GetCargoDetailsResponse>) => {
		if (cargoDetails?.id == null) {
			return;
		}

		const [key, value] = Object.entries(values)[0];

		if (key == null) {
			return;
		}

		if (cargoDetails[key as keyof GetCargoDetailsResponse] === value) {
			return;
		}

		handleChange(cargoDetails.id, {
			[key]: value,
		} as Partial<GetCargoDetailsResponse>);
	}, [cargoDetails, handleChange]);

	if (!cargoDetails) {
		return null;
	}

	return (
		<div style={{ marginTop: 28 }}>
			<EditableDetails
				title="Laytime"
				// @ts-ignore
				items={getLaytimeFields({
					mode,
					cargoDetails,
					laytimeTerms,
				})}
				// @ts-ignore
				onEditValuesChange={handleEdit}
				editing
				hideHeader
				labelWidth={200}
			/>
		</div>
	);
};

export default LaytimeDetails;
